import React from "react";
import { CircularProgress, Grid, Typography } from "@mui/material";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { useTheme } from "@mui/material/styles";
import GradientCard from "../gradients/GradientCard";
import StyledTabIconBox from "../StyledTabIconBox";
import StyledPatchFavoriteButton from "../StyledPatchFavoriteButton";
import StyledPatchPointsBadge from "../StyledPatchPointsBadge";
import { errorMessages } from "../../data/error-messages";

const CustomizerDrawerMenuPage = ({
  items,
  firstItemWide,
  isFavorites,
  selectedItemIndex,
  loading,
  handleCardClick,
  icon = "icon",
  label = "label",
  columns = 3,
  isPatch,
  favoritePatches,
  handleFavoritePatch,
}) => {
  const theme = useTheme();

  const handleFavoritePatchClick = (event, item) => {
    event.stopPropagation();
    handleFavoritePatch(item);
  };

  return (
    <>
      {loading ? (
        <Grid item mobile={3}>
          <GradientCard
            variant="square"
            sxMobile={{
              minHeight: "114px",
              boxShadow: "none",
              borderColor: "transparent",
              paddingBottom: "100%",
            }}
            background="transparent"
          >
            <CircularProgress />
          </GradientCard>
        </Grid>
      ) : items?.length ? (
        items.map((item, index) => (
          <Grid
            item
            key={index}
            mobile={firstItemWide && index === 0 ? 3 : columns === 3 ? 1 : 1.5}
          >
            <GradientCard
              selected={index === selectedItemIndex}
              onClick={() => handleCardClick(index)}
              variant="square"
              sxMobile={{
                minHeight: "114px",
                borderRadius: "9px",
                boxShadow: "0px 4px 24px 0px rgba(171, 171, 171, 0.25)",
                paddingBottom: firstItemWide && index === 0 ? "50%" : "100%",
              }}
              sxInnerMobile={{
                padding: "12px",
                borderRadius: "9px",
              }}
              background={theme.palette.background.paper}
            >
              <Typography
                variant="h4"
                sx={{
                  flexShrink: "0",
                  maxWidth: "100%",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                {item[label]}
              </Typography>
              <StyledTabIconBox>
                <img
                  src={item[icon]}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              </StyledTabIconBox>
              {isPatch && (
                <>
                  <StyledPatchFavoriteButton onClick={(e) => handleFavoritePatchClick(e, item)}>
                    {favoritePatches?.some((e) => e?.id === item.id) ? (
                      <FavoriteIcon htmlColor="#3982B8" />
                    ) : (
                      <FavoriteBorderIcon />
                    )}
                  </StyledPatchFavoriteButton>
                  <StyledPatchPointsBadge>{item.points}</StyledPatchPointsBadge>
                </>
              )}
            </GradientCard>
          </Grid>
        ))
      ) : (
        <Typography
          variant="h3"
          sx={{
            width: "100%",
            paddingTop: "64px",
            textAlign: "center",
            paddingBottom: "20px",
            paddingInline: "20px",
          }}
        >
          {isFavorites ? errorMessages.FAVORITES_EMPTY : errorMessages.PATCHES_EMPTY}
        </Typography>
      )}
    </>
  );
};

export default CustomizerDrawerMenuPage;
